import { CompanyTypeEnum } from "@gtpl/shared-models/masters"
import { EnquiryLifecycleStatusEnum, OrderTypeEnum, SourceFromEnum } from "../enum"
import { EnquiryPackBomModel } from "./enq-pack-bom-model"
import { EnquiryProductModel } from "./enq-product-model"

export class EnquiryByIdModel{
    enquiryId:number
    orderType: OrderTypeEnum
    sourceFrom:SourceFromEnum
    agentId:number
    clientName: string
    buyerId:number
    endCustomerName: string
    salePersonId:number
    enquiryDate:Date
    etd:Date
    toEtd:Date
    eta:Date
    agentAddressId:number
    agentAddress: string
    buyerAddressId:number
    buyerAddress: string
    countryId:number
    countryName: string
    destinationId:number
    destinationName: string
    deliveryTermsId:number
    deliveryTermsName: string
    paymentTermsId:number
    paymentTermsName: string
    shipmentTermsId:number
    shippingTermName: string
    processingUnitId:number
    processingUnit: string
    manufacturingUnitId:number
    manufacturingUnit: string
    currencyId:number
    currencyName: string
    noOfContainers:number
    salesCommission:number
    remarks:string
    productDetails:EnquiryProductModel[]
    uomId:number
    uom: string
    unitName:string
    rejectReason:string

    // enquiryPackBom: EnquiryPackBomModel[]
    enquiryNumber?: string
    manufacturingUnitCompany?:CompanyTypeEnum
    constructor(
        enquiryId:number,
        orderType: OrderTypeEnum,
        sourceFrom:SourceFromEnum,
        agentId:number,
        clientName: string,
        buyerId:number,
        endCustomerName: string,
        salePersonId:number,
        enquiryDate:Date,
        etd:Date,
        toEtd:Date,
        eta:Date,
        agentAddressId:number,
        agentAddress: string,
        buyerAddressId:number,
        buyerAddress: string,
        countryId:number,
        countryName: string,
        destinationId:number,
        destinationName: string,
        deliveryTermsId:number,
        deliveryTermsName: string,
        paymentTermsId:number,
        paymentTermsName: string,
        shipmentTermsId:number,
        shippingTermName: string,
        processingUnitId:number,
        processingUnit: string,
        manufacturingUnitId:number,
        manufacturingUnit: string,
        currencyId:number,
        currencyName: string,
        noOfContainers:number,
        salesCommission:number,
        remarks:string,
        productDetails:EnquiryProductModel[],
        // enquiryPackBom: EnquiryPackBomModel[],
        uomId:number,
        uom:string,
        unitName:string,
        rejectReason:string,
        enquiryNumber?: string,
        manufacturingUnitCompany?:CompanyTypeEnum
    ){
        this.enquiryId=enquiryId
        this.orderType=orderType
        this.sourceFrom=sourceFrom
        this.agentId=agentId
        this.clientName = clientName
        this.buyerId=buyerId
        this.endCustomerName = endCustomerName
        this.salePersonId=salePersonId
        this.enquiryDate=enquiryDate
        this.agentAddressId=agentAddressId
        this.agentAddress = agentAddress
        this.buyerAddressId=buyerAddressId
        this.buyerAddress = buyerAddress
        this.countryId=countryId
        this.countryName = countryName
        this.destinationId=destinationId
        this.destinationName = destinationName
        this.etd=etd
        this.toEtd = toEtd
        this.eta=eta
        this.deliveryTermsId=deliveryTermsId
        this.deliveryTermsName = deliveryTermsName
        this.paymentTermsId=paymentTermsId
        this.paymentTermsName = paymentTermsName
        this.shipmentTermsId=shipmentTermsId
        this.shippingTermName = shippingTermName
        this.processingUnitId=processingUnitId
        this.processingUnit = processingUnit
        this.manufacturingUnitId=manufacturingUnitId
        this.manufacturingUnit = manufacturingUnit
        this.currencyId=currencyId
        this.currencyName = currencyName
        this.noOfContainers=noOfContainers
        this.salesCommission=salesCommission
        this.remarks=remarks
        this.productDetails=productDetails
        // this.enquiryPackBom = enquiryPackBom
        this.uomId = uomId
        this.uom = uom 
        this.enquiryNumber = enquiryNumber
        this.unitName=unitName
        this.rejectReason=rejectReason
        this.manufacturingUnitCompany = manufacturingUnitCompany

    }

}